import { css } from 'styled-components';

const breakpoints = {
  xs: '320px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1400px'
};

export const media = Object.keys(breakpoints).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${breakpoints[label]}) {
      ${css(...args)}
    }
  `;
  return acc;
}, {});

export const sectionStyles = css`
  padding: 6rem 0;
  width: 100%;
  position: relative;
  overflow: hidden;
  
  ${media.lg`
    padding: 4rem 0;
  `}
  
  ${media.md`
    padding: 3rem 0;
  `}
`;

export const contentStyles = css`
  width: 100%;
  position: relative;
  z-index: 1;
  
  ${media.md`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  `}
`;

export const titleStyles = css`
  h2 {
    font-size: 48px;
    font-weight: bold;
    line-height: 1.2;
    margin: 0;
    
    ${media.md`
      font-size: 40px;
      text-align: center;
    `}
    
    ${media.sm`
      font-size: 32px;
      text-align: center;
    `}
  }

  ${media.md`
    text-align: center;
    width: 100%;
  `}

  .highlight {
    color: #FF4D00;
    background: #FFF0E6;
    padding: 0.25rem 1rem;
    border-radius: 100px;
    display: inline-block;
  }
`;

export const decorationStyles = css`
  position: absolute;
  right: 0;
  top: 0;
  width: 33.333%;
  height: 100%;
  z-index: 0;
  
  ${media.md`
    display: none;
  `}
`;

export const fullWidthStyles = css`
  width: 100%;
  padding: 0;
  
  > div {
    width: 100%;
    max-width: none;
  }
`;

export const gridStyles = css`
  display: grid;
  gap: 24px;
  width: 100%;
  position: relative;
  z-index: 1;
  
  ${media.lg`
    gap: 20px;
  `}
  
  ${media.md`
    gap: 16px;
    max-width: 90%;
    margin: 0 auto;
    justify-items: center;
  `}
  
  ${media.sm`
    grid-template-columns: 1fr;
    max-width: 400px;
  `}
`;

export const descriptionStyles = css`
  font-size: 1.2rem;
  color: #666666;
  margin: 2rem 0;
  line-height: 1.6;
  max-width: 600px;

  ${media.md`
    text-align: center;
    margin: 1.5rem auto;
    padding: 0 1rem;
  `}
`;

export const cardStyles = css`
  padding: 1.25rem;
  
  ${media.lg`
    padding: 1rem;
  `}
  
  ${media.md`
    padding: 1.5rem;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  `}
`;

// Общие стили для основного контейнера контента
export const mainContentStyles = css`
  width: 62.666%;  // Возвращаем ширину 2/3
  margin-left: 5%;
  padding-right: 40px;
  display: flex;
  position: relative;
  z-index: 1;
  
  ${media.lg`
    width: 60%;
    margin-right: 35%;
    padding-right: 20px;
  `}
  
  ${media.md`
    width: 90%;
    margin: 0 auto;
    padding: 0 20px;
    text-align: center;
    align-items: center;
    flex-direction: column;
  `}
`;

export const buttonStyles = css`
  ${media.md`
    margin: 0 auto;
    display: block;
  `}
`; 